export default __webpack_public_path__ + "d3a596dfdb0674aca5be59d8ec1dabe2.svg";